import { useState, Suspense } from 'react'
import lazyWithRetry from '../../utils/lazyWithRetry'
import '../../styles/counseling/CounselingHome.css'
import { usePageTitle } from '../../utils/util'
import { useUrlState } from '../../hooks/useUrlState'
import CreateWellbeingProfileModal from '../modals/CreateWellbeingProfileModal'
import CounsellingLeftSideSkeleton from './skeleton/CounsellingLeftSideSkeleton'
import { TypeOptionsListsSkeleton, WellReminderHeaderSkeleton } from './skeleton/CounsellingHomeSkeleton'

const ClounsellingProfilesList = lazyWithRetry(() => import('./components/ClounsellingProfilesList'), './components/ClounsellingProfilesList')

const WellReminderHeader = lazyWithRetry(() => import('./components/WellReminderHeader'), './components/WellReminderHeader')

const TypeOptionsLists = lazyWithRetry(() => import('./components/TypeOptionsLists'), './components/TypeOptionsLists')

// Tolerant of the older "any value means true" links while still honouring an
// explicit false, which the previous !!query.get() seed read as true.
const assignedActionsCodec = {
    parse: (raw) => !(raw === 'false' || raw === '0' || raw === ''),
    serialize: (v) => (v ? 'true' : 'false'),
}

function CounselingHome() {
    usePageTitle('Upstrive Education - Wellbeing Tracker')

    const [loading, setLoading] = useState(true)
    // setStatus was never called, so this is effectively a constant.
    const status = 'open'
    const [searchText, setSearchText] = useUrlState('search', '', { debounce: 700 })
    const [typeOption, setTypeOption] = useUrlState('assignedActions', false, assignedActionsCodec)
    const [showWellbeingModal, setShowWellbeingModal] = useState(false)
    const [hoveredButton, setHoveredButton] = useState(false)

    const closeWellbeingModal = () => {
        setShowWellbeingModal(false)
    }
    const openWellbeingModal = () => {
        setShowWellbeingModal(true)
    }

    return (
        <div className="well-container bg-[#ECEBF8]">
            <Suspense fallback={<CounsellingLeftSideSkeleton />}>
                <ClounsellingProfilesList
                    searchText={searchText}
                    setLoading={setLoading}
                    status={status}
                    openWellbeingModal={openWellbeingModal}
                    setSearchText={setSearchText}
                    loading={loading}
                />
            </Suspense>
            <div className="well-reminder-container">
                <Suspense fallback={<WellReminderHeaderSkeleton />}>
                    <WellReminderHeader typeOption={typeOption} setTypeOption={setTypeOption} hoveredButton={hoveredButton} setHoveredButton={setHoveredButton} />
                </Suspense>
                <div className="well-tracker-list light-small-scroll">
                    <div style={{ paddingRight: 10 }}>
                        <Suspense fallback={<TypeOptionsListsSkeleton />}>
                            <TypeOptionsLists typeOption={typeOption} />
                        </Suspense>
                    </div>
                </div>
            </div>
            <CreateWellbeingProfileModal modalIsOpen={showWellbeingModal} closeModal={closeWellbeingModal} />
        </div>
    )
}

export default CounselingHome
